import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

export default function ComboBox({ list, value, onChange }) {
  let { t } = useTranslation();

  return (
    <>
      <input
        list="teckskillList"
        className="form-control"
        name="selected"
        onChange={onChange}
        value={value || ""}
        placeholder={t("Search or start typing skills...")}
        maxLength={50}
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      />
      <datalist id="teckskillList">
        {list.map((itemList) => (
          <option key={itemList.Key} value={t(itemList.description)} />
        ))}
      </datalist>
    </>
  );
}
ComboBox.propTypes = {
  list: PropTypes.array.isRequired,
  onchange: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired
};
